import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';

import { AddMarketIcon } from './components/MethodIcons';

export function MarketsEmptyState({ onAdd }: { onAdd: () => void }) {
  const { t } = useTranslation('markets');

  return (
    <div className="flex w-full flex-col items-center justify-center rounded-[4px] bg-[#f5f5f5] p-6">
      <div className="flex w-[422px] max-w-full flex-col items-center gap-[13px]">
        <span className="flex size-[68px] items-center justify-center rounded-xl bg-[#e4e4e4]">
          <AddMarketIcon className="size-8 text-black" />
        </span>
        <h3 className="text-center text-xl font-medium tracking-[-0.6px] text-black">
          {t('empty.title')}
        </h3>
        <p className="text-center text-sm text-muted-foreground">{t('empty.description')}</p>
        <Button onClick={onAdd}>{t('empty.cta')}</Button>
      </div>
    </div>
  );
}
